import React from 'react';
import { DataTableColumn } from '../../Base/Components/DataTable/DataTable';
import {
	InsuranceCompanyBatch,
	InsuranceCompanyBatchesTable,
	InvoiceBatch,
} from './InsuranceCompanyBatchesDefaultColumns.const';
import ManagerInsuranceCompaniesBatchDownload from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesBatchesList/ManagerInsuranceCompaniesBatchDownload';
import ManagerInsuranceCompaniesBatchCreateTableDelete from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesBatchCreateTable/ManagerInsuranceCompaniesBatchCreateTableDelete';
import ManagerInsuranceCompaniesBatchInvoiceAction from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesBatchInvoice/ManagerInsuranceCompaniesBatchInvoiceAction';
import ManagerInsuranceCompaniesBatchStatusBadge from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesBatchStatus/ManagerInsuranceCompaniesBatchStatusBadge';
import { resolveInvoiceBatchDisplayStatus } from './InsuranceCompanyBatchStatus.const';

export interface InsuranceCompanyBatchesCreateTable
	extends InsuranceCompanyBatchesTable {
	onDelete: (id: string) => void;
}

export const InsuranceCompanyBatchesCreateColumns: DataTableColumn<
	InsuranceCompanyBatch,
	InsuranceCompanyBatchesCreateTable
>[] = [
	{
		key: 'dcid',
		label: 'component.insuranceCompanyBatch.table.dcid',
		bold: true,
		renderItem: item => item.dcid,
	},
	{
		key: 'insuranceCompanyCode',
		label: 'component.insuranceCompanyBatch.table.insuranceCompanyCode',
		renderItem: item => item.insuranceCompanyCode,
	},
	{
		key: 'dtyp',
		label: 'component.insuranceCompanyBatch.table.dtyp',
		renderItem: item => item.dtyp,
	},
	{
		key: 'periodMonth',
		label: 'component.insuranceCompanyBatch.table.periodMonth',
		renderItem: item => item.periodMonth,
	},
	{
		key: 'periodYear',
		label: 'component.insuranceCompanyBatch.table.periodYear',
		renderItem: item => item.periodYear,
	},
	{
		key: 'batchStatus',
		label: 'component.insuranceCompanyBatch.table.batchStatus',
		renderItem: item =>
			item.batchStatus ? (
				<ManagerInsuranceCompaniesBatchStatusBadge status={item.batchStatus} />
			) : undefined,
	},
	{
		key: 'invoiceStatus',
		label: 'component.insuranceCompanyBatch.table.invoiceStatus',
		renderItem: item => {
			const status = resolveInvoiceBatchDisplayStatus(item);

			return status ? (
				<ManagerInsuranceCompaniesBatchStatusBadge status={status} />
			) : undefined;
		},
	},
	{
		key: 'downloadFile',
		label: 'component.insuranceCompanyBatch.table.downloadFile',
		renderItem: item => (
			<ManagerInsuranceCompaniesBatchDownload file={item.file} />
		),
	},
	{
		key: 'invoice',
		label: 'component.insuranceCompanyBatch.table.invoice',
		renderItem: (item, table) => (
			<ManagerInsuranceCompaniesBatchInvoiceAction
				batch={item}
				onInvoiceCreated={invoiceBatch =>
					table?.onInvoiceCreated?.(item.id, invoiceBatch)
				}
			/>
		),
	},
	{
		key: 'delete',
		label: 'base.shared.remove',
		renderItem: (item, { onDelete }) => (
			<ManagerInsuranceCompaniesBatchCreateTableDelete
				id={item.id}
				onDelete={onDelete}
			/>
		),
	},
];

export type { InvoiceBatch };
